import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=6d46b9ae&"
import script from "./user-add.vue?vue&type=script&lang=js&"
export * from "./user-add.vue?vue&type=script&lang=js&"
import style0 from "./user-add.vue?vue&type=style&index=0&id=6d46b9ae&prod&lang=scss&"
import style1 from "./user-add.vue?vue&type=style&index=1&id=6d46b9ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports